import axiosClient from 'utils/axiosClient';
import api from 'api';

const getReportClassrooms = async (data: any) => {
	const response = await axiosClient.get(api.REPORTS.REPORTS_CLASSROOMS, {params: data});
	return response.data;
};

const getReportProgress = async (data: any) => {
	const response = await axiosClient.get(api.REPORTS.REPORTS_PROGRESS, {params: data});
	return response.data;
};

const getReportScoreOfCertifications = async (data: any) => {
	const response = await axiosClient.get(api.REPORTS.REPORTS_SCORE_OF_CERTIFICATION, {params: data});
	return response.data;
};

const getReportScoreOfCertificationsSubjects = async (data: any) => {
	const response = await axiosClient.get(api.REPORTS.REPORTS_SCORE_OF_CERTIFICATION_SUBJECTS, {
		params: data
	});
	return response.data;
};

const service = {
	getReportClassrooms,
	getReportProgress,
	getReportScoreOfCertifications,
	getReportScoreOfCertificationsSubjects
};

export default service;
